import React from 'react';
import '../less/ConditionsBlock.less';

export default function template() {
    const {className, isMobile, page, data} = this.props;

  const items = data.items.map(item => {
    const text =  this.l10n(item.desc);
        return (
          <div className={`${className}-item items-wrapper-item`}>
            <div className="item-title" dangerouslySetInnerHTML={{ __html:this.l10n(item.title)}}></div>
            <div className="item-text" dangerouslySetInnerHTML={{ __html: text}}></div>
          </div>
        )
      });


    return (
        <div className={`${page}-wrapper conditions-block`}>
          <div className="title">{this.l10n(data.title)}</div>
          <div className={`${className} items-wrapper`}>{items}</div>
        </div>
    );
}
